<template>
  <b-modal
    :no-close-on-backdrop="true"
    :id="modalId"
    :title="$t('common.delete-item')"
    ok-only
    :ok-title="$t('common.delete')"
    @ok="$emit('deleteToggle')"
  >
    <b-card-text>
      <h5>{{ $t('common.delete-sure') }}</h5>
      {{ $t('common.sure-click') }}
    </b-card-text>
  </b-modal>
</template>

<script>
import { BModal, BCardText } from 'bootstrap-vue';
export default {
  components: {
    BModal,
    BCardText,
  },
  props: ['modalId'],
  data() {
    return {};
  },
};
</script>
